import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { activityOpenSelector } from '../../selectors/events/filter';
import { notificationsSelector } from '../../selectors/events/timetable';
import { toggleActivityOpen } from '../../actions/events/filter';
import { fetchNotifications } from '../../actions/events/timetable';
import { isAfter, msToHour, msToTime, weekDayAndDate, weekDayAndHour } from '../../lib/date.utils';
import { filter, get } from 'lodash';
import {
    activityTypeToText,
    COMMENT_CHANGE,
    DELETE_PERFORMANCE,
    RESCHEDULED_ARTIST,
    RESCHEDULED_DATE_STAGE,
    RESCHEDULED_HOUR,
    STATUS_CHANGED
} from '../../constants/activity';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { favOrUnfavArtist, setNotificationsSeen } from '../../actions/authentication';
import star from '../../assets/images/star.svg';
import { favoriteArtistsSelector } from '../../selectors/authentication';
import FavoriteStar from '../../components/application/events/FavoriteStar';

class Activity extends Component {
    state = { onlyFavs: false };
    componentDidMount() {
        this._fetch();
    }
    componentDidUpdate() {
        this._fetch();
    }
    _switchToAll = () => {
        this.setState({ onlyFavs: false });
    };
    _switchToFavs = () => {
        this.setState({ onlyFavs: true });
    };

    _onClose = () => {
        this.props.toggleActivityOpen();
        this.props.setNotificationsSeen();
    };
    _fetch = () => {
        const { fetching, fetched } = this.props.notifications;
        if (!fetching && !fetched) {
            this.props.fetchNotifications(this.props.eventId);
        }
    };
    _renderCardTitle = n => {
        return (
            <span className="ckp-events-activity__cardtitle">
                {n.type === RESCHEDULED_ARTIST ? `${get(n, 'meta.before.artist', '')} changed to ` : null}
                <span className="u-bold">{get(n, 'meta.artist', '')}</span>
            </span>
        );
    };
    _renderCardBody = n => {
        return (
            <React.Fragment>
                <span className="ckp-events-activity__cardbody">
                    <span>
                        {n.type === RESCHEDULED_DATE_STAGE ? (
                            <span className="ckp-events-activity__cardtext">
                                <span>{`${get(n, 'meta.before.stage', '')} (${weekDayAndDate(
                                    get(n, 'meta.before.date', '')
                                )})`}</span>
                                <span> changed to </span>
                                <span className="u-bold-black">{`${get(n, 'meta.stage', '')} (${weekDayAndDate(
                                    get(n, 'meta.date', '')
                                )})`}</span>
                            </span>
                        ) : (
                            get(n, 'meta.stage', '')
                        )}
                    </span>
                    <span className="ckp-events-activity__cardtext">
                        {n.type === RESCHEDULED_HOUR ? (
                            <React.Fragment>
                                <span>
                                    {weekDayAndHour(
                                        get(n, 'meta.date'),
                                        msToHour(get(n, 'meta.before.start')),
                                        msToHour(get(n, 'meta.before.end')),
                                        true
                                    )}
                                </span>
                                <span> changed to </span>
                                <span className="u-bold-black">{`${msToHour(get(n, 'meta.start'))} - ${msToHour(
                                    get(n, 'meta.end')
                                )}`}</span>
                            </React.Fragment>
                        ) : n.type === RESCHEDULED_DATE_STAGE ? null : (
                            weekDayAndHour(
                                get(n, 'meta.date'),
                                msToHour(get(n, 'meta.start')),
                                msToHour(get(n, 'meta.end')),
                                true
                            )
                        )}
                    </span>
                </span>
            </React.Fragment>
        );
    };
    _renderCardBottom = n => {
        return n.type === STATUS_CHANGED ? (
            <span className="ckp-events-activity__clearing">
                <span className="ckp-events-activity__cardtext">
                    <span className="u-bold-black">LIVE{'  '}</span>
                    <span className="u-uppercase-inline">
                        {get(n, 'meta.before.clearing.live', '').replace(/_/g, ' ')}
                    </span>
                    <span> changed to </span>
                    <span className="u-bold-black u-uppercase-inline">
                        {get(n, 'meta.after.clearing.live', '').replace(/_/g, ' ')}
                    </span>
                </span>
                <span className="ckp-events-activity__cardtext">
                    <span className="u-bold-black">NON LINEAR{'  '}</span>
                    <span className="u-uppercase-inline">
                        {get(n, 'meta.before.clearing.nonLinear', '').replace(/_/g, ' ')}
                    </span>
                    <span> changed to </span>
                    <span className="u-bold-black u-uppercase-inline">
                        {get(n, 'meta.after.clearing.nonLinear', '').replace(/_/g, ' ')}
                    </span>
                </span>
            </span>
        ) : n.type === COMMENT_CHANGE ? (
            <span className="ckp-events-activity__foot">
                <span className="ckp-events-activity__comments">{get(n, 'meta.after.comments')}</span>
            </span>
        ) : null;
    };

    render() {
        const filteredActivities = filter(this.props.notifications.data || [], n => {
            const favFilter = this.state.onlyFavs ? this.props.favoriteArtists.includes(n.artistId) : true;
            return favFilter && (n.partnerId === this.props.selectedPartner || n.partnerId === 'ALL_PARTNERS');
        });
        return (
            <div className={`ckp-events-activity ${this.props.isOpen ? 'ckp-events-activity--open' : ''}`}>
                <IconButton className="ckp-events-activity__close" onClick={this._onClose} color="inherit">
                    <CloseIcon />
                </IconButton>
                <h2 className="ckp-ts-h1 ckp-events-activity__title">Activity</h2>
                <span className="ckp-ts-h1 ckp-events-activity__line"></span>
                <div className="ckp-events-activity__options">
                    <ul className="ckp-timetable-actions-group is-not-responsive is-black-text">
                        <li
                            onClick={this._switchToAll}
                            className={`ckp-timetable-actions-option ${this.state.onlyFavs ? '' : 'is-selected'}`}
                        >
                            All activities
                        </li>
                        <li
                            onClick={this._switchToFavs}
                            className={`ckp-timetable-actions-option ${this.state.onlyFavs ? 'is-selected' : ''}`}
                        >
                            <img src={star} alt="Favorite" />
                        </li>
                    </ul>
                </div>
                <ul className="ckp-events-activity__list">
                    {filteredActivities.map(n => (
                        <li className="ckp-events-activity__item" key={n.id}>
                            <h6 className="ckp-ts-h4 ckp-events-activity__top">
                                <span className="ckp-events-activity__time">{msToTime(n.createdAt, true)}</span>
                                <span>{activityTypeToText(n.type)}</span>
                            </h6>
                            <div
                                onClick={() => this.props.openEntryFromActivity(n.performanceId)}
                                className={`ckp-events-activity__card ${
                                    isAfter(n.createdAt, this.props.seenAt) ? 'ckp-events-activity__card--dotted' : ''
                                } ${n.type === DELETE_PERFORMANCE ? 'ckp-events-activity__card--deleted' : ''}`}
                            >
                                <FavoriteStar
                                    favOrUnfavArtist={this.props.favOrUnfavArtist}
                                    artistId={n.artistId}
                                    isFavorite={this.props.favoriteArtists.includes(n.artistId)}
                                />
                                {this._renderCardTitle(n)}
                                {this._renderCardBody(n)}
                                {this._renderCardBottom(n)}
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    notifications: notificationsSelector(state),
    isOpen: activityOpenSelector(state),
    favoriteArtists: favoriteArtistsSelector(state)
});

const mapDispatchToProps = dispatch =>
    bindActionCreators({ toggleActivityOpen, setNotificationsSeen, favOrUnfavArtist, fetchNotifications }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Activity);



// WEBPACK FOOTER //
// ./src/containers/events/Activity.js